module.exports = __webpack_public_path__ + "static/media/plane_w_sar.534bb86a.png";